var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"page",class:[
    'icon icon-' + _vm.node.kind,
    { 'router-link-exact-active': _vm.node.fqdn === _vm.$route.meta.fqdn },
  ],attrs:{"href":_vm.parseHref(_vm.node.fqdn, '/docs/'),"title":_vm.parseLanguage(_vm.node.title)},on:{"click":function($event){$event.preventDefault();return _vm.goToLink(_vm.node.fqdn)}}},[_vm._v("\n  "+_vm._s(_vm.parseLanguage(_vm.node.title))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }